import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import Default from './layouts/Default'
import Empty from './layouts/Empty'

import App from './App.vue'
import router from './router'
import VueYouTubeEmbed from 'vue-youtube-embed'
import SkillsService from './services/SkillsService'
import AdvisoryBoardService from './services/AdvisoryBoardService'

Vue.component('default-layout', Default)
Vue.component('empty-layout', Empty)

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.prototype.$skillsService = new SkillsService()
Vue.prototype.$advisoryBoardService = new AdvisoryBoardService()

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.VUE_APP_BACKEND
// No need for a response interceptor, need to intercept errors to resolve 401 hang
Vue.axios.interceptors.response.use(null, function (error) {
  if (error.response.status === 401) {
    const isFivenomics = process.env.VUE_APP_SKIN === 'fivenomics'
    const path = isFivenomics ? '/welcome' : '/login'
    router.push(path)
  }
  return Promise.reject(error)
})

let options = {
    auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
    http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
    router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
    authRedirect: null
}

// if (process.env.VUE_APP_SKIN !== 'fivenomics')
//     delete options.authRedirect

Vue.use(require('@websanova/vue-auth'), options)

// Must be set up AFTER vue-auth creation, or auth will not be ready for first check
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.auth)
  const currentUser = Vue.auth.check()

  if (requiresAuth && !currentUser) {
    const isFivenomics = process.env.VUE_APP_SKIN === 'fivenomics'
    const path = isFivenomics ? '/welcome' : '/login'
    sessionStorage.setItem('loginRedirectPath', to.path)
    next(path)
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})

Vue.use(VueYouTubeEmbed)

let vue = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// Giving SkillsService (and any other services access to http to provide standardized results)
SkillsService.prototype.$http = vue.$http
AdvisoryBoardService.prototype.$http = vue.$http
